import * as React from 'react';

interface IQuantityProps {
    id: string;
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
    ariaLabel?: string;
}

const QuantityComponent: React.FunctionComponent<IQuantityProps> = (props) => {
    const { value, min, max, onChange, ariaLabel } = props;
    const clamp = (val: number) => Math.min(Math.max(val, min), max);

    return (
        <ul className="cart-table-price">
            <li>
                <span className="value">
                    <button type="button" className="value-button" onClick={() => onChange(clamp(value - 1))}>
                        -
                    </button>
                    <span className="number" aria-label={`${ariaLabel} - ${value}`}>
                        {value}
                    </span>
                    <button type="button" className="value-button" onClick={() => onChange(clamp(value + 1))}>
                        +
                    </button>
                </span>
            </li>
        </ul>
    );
};

QuantityComponent.displayName = 'QuantityComponent';

export default QuantityComponent;
